import sessionStorage from 'sessionstorage'
import { addMinutes } from 'date-fns'
import get from 'lodash/get'

const SESSION_TTL_MINUTES = 300

export function storeKeyInSession(requestType, searchResult) {
  const searchSessionKey = get(
    searchResult,
    'data.airSearchRsp.searchSessionKey',
    false
  )
  if (requestType === 'airSearchReq' && searchSessionKey) {
    sessionStorage.setItem('searchSessionKey', searchSessionKey)
    sessionStorage.setItem(
      'searchSessionKeyExpirationTime',
      addMinutes(Date.now(), SESSION_TTL_MINUTES)
    )
    sessionStorage.setItem('searchSessionKeyURL', window.location.href)
    const elapsedTime = get(
      searchResult,
      'data.airSearchRsp.elapsedTime',
      false
    )
    if (elapsedTime) {
      sessionStorage.setItem('airSearchReqElapsedTime', elapsedTime)
    }
  }
}

export function shouldPerformSessionKeySearch() {
  // Call airSearchDisplay instead of airSearch in Variant case with search session key under 300 minutes old
  return searchSessionKey() && sessionStillValid() && sessionMatchesCurrentURL()
}

export function sessionMatchesCurrentURL() {
  return sessionStorage.getItem('searchSessionKeyURL') === window.location.href
}

export function sessionStillValid() {
  return (
    new Date() <
    new Date(sessionStorage.getItem('searchSessionKeyExpirationTime'))
  )
}

export function searchSessionKey() {
  return !!sessionStorage.getItem('searchSessionKey')
}
